// select column id is used to identify the column which is used for row selection
// This is added internally to the columns array to handle row selection based

import type { TableRowSelectionConfig } from "./Table.types";

// on the canEnableRowSelection prop
export const SELECT_ROW_COLUMN_ID = "selectRows";
export const EXPAND_ROW_COLUMN_ID = "expandRows";

// Default cell padding using Catalyst spacing values
export const DEFAULT_CELL_PADDING = "8 16";

// Default pagination state
export const DEFAULT_PAGINATION_STATE = {
  pageIndex: 1,
  pageSize: 10
};

/** Typed with TableRowSelectionConfig to prevent narrow typing which requires onSelect as selectedRows is declared. */
export const DEFAULT_ROW_SELECTION_CONFIG: TableRowSelectionConfig<any> = {
  enabled: false,
  isMultiple: true,
  // Stable default object to prevent infinite re-renders
  selectedRows: {},
  onChange: () => {}
} as const;
